import React from 'react';
import { Tag } from 'antd';
import { inject, observer } from 'mobx-react';

const LIVING_STATUS = {
  0: {
    color: 'gray',
  },
  1: {
    color: '#87d068',
  },
  2: {
    color: 'red',
  },
  3: {
    color: 'black',
  },
};

@inject('app')
@observer
class Status extends React.Component {
  render() {
    const { code, app } = this.props;
    const { langs } = app;
    if (!code) {
      return null;
    }
    const { color } = LIVING_STATUS[code] || LIVING_STATUS[3];
    return (
      <Tag color={color}>
        {langs[`live_status_enum_${code}`] || langs[`live_status_enum_3`]}
      </Tag>
    );
  }
}

export default Status;



// WEBPACK FOOTER //
// ./src/views/live/fb/components/status.js